import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, retry, shareReplay } from 'rxjs/operators';


export const configServiceInitializer = (configService: ConfigurationService<any>) => (): Observable<void> => configService.loadConfig();

@Injectable({
  providedIn: 'root'
})
/**
 * Abstract ConfigurationService
 * Extend this service and implement the getConfiguration() method to load a configuration object
 * A vertical can use this service to provide configurations depending on a html meta tag called "env"
 *
 * See tests for a dummy implementation
 *
 */
export abstract class ConfigurationService<C> {
  private _currentEnv = 'local';
  private _config: any;

  private readonly metaTagNameEnvironment = 'env';


  get config(): C {
    return this._config;
  }

  get currentEnv(): string {
    return this._currentEnv;
  }

  loadConfig(): Observable<void> {
    this._currentEnv = this.getEnvName();
    return this.getConfiguration().pipe(
      retry(3),
      map((data) => {
        this._config = data;
      }),
      shareReplay(1)
    );
  }

  private getEnvName(): string {
    const metaElement = document.querySelector(`meta[name=${this.metaTagNameEnvironment}]`);

    if (metaElement) {
      const envName = metaElement.getAttribute('content');
      if (envName && envName !== '') {
        return envName.toLowerCase();
      }
    }
    // default
    return this._currentEnv;
  }

  protected abstract getConfiguration(): Observable<C>;
}
